import { NextRouter } from 'next/router'

export const parseStepIndex = (max: number, stepIndex?: string | number) => {
  const parsedStep = Number(stepIndex)
  return Number.isNaN(parsedStep) || parsedStep < 0 || parsedStep > max
    ? 0
    : parsedStep
}

export const setActiveStepIndex = (
  router: NextRouter,
  max: number,
  newStepIndex: number
) => {
  const newActiveStepIndex = parseStepIndex(max, newStepIndex)

  // eslint-disable-next-line no-param-reassign
  router.query.stepIndex = `${newActiveStepIndex}`
  router.push({ pathname: router.pathname, query: router.query })
}
